export const COOKIE_CONSENT_CHANGED_EVENT = 'gf-cookie-consent-changed'
export const COOKIE_CONSENT_OPEN_EVENT = 'gf-cookie-consent-open'
export const COOKIE_CONSENT_STORAGE_KEY = 'gf_cookie_consent_v3'
const COOKIE_CONSENT_VERSION = 3

function parseStoredConsent(value) {
  if (!value) return null

  try {
    const parsed = JSON.parse(value)
    if (
      typeof parsed !== 'object' ||
      parsed === null ||
      typeof parsed.analytics !== 'boolean' ||
      typeof parsed.advertising !== 'boolean'
    ) {
      return null
    }

    return {
      version:
        typeof parsed.version === 'number'
          ? parsed.version
          : COOKIE_CONSENT_VERSION,
      necessary: true,
      analytics: parsed.analytics,
      advertising: parsed.advertising,
      updatedAt:
        typeof parsed.updatedAt === 'string'
          ? parsed.updatedAt
          : new Date().toISOString(),
    }
  } catch {
    return null
  }
}

function readLocalStorage(key) {
  if (typeof window === 'undefined') return null

  try {
    return window.localStorage?.getItem(key) ?? null
  } catch {
    return null
  }
}

export function getCookieConsentPreferences() {
  return parseStoredConsent(readLocalStorage(COOKIE_CONSENT_STORAGE_KEY))
}

export function hasAdvertisingCookieConsent() {
  const consent = getCookieConsentPreferences()
  return consent?.advertising === true
}
